import { render, staticRenderFns } from "./CreateDNSRecord.vue?vue&type=template&id=86553b18&scoped=true"
import script from "./CreateDNSRecord.vue?vue&type=script&lang=js"
export * from "./CreateDNSRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86553b18",
  null
  
)

export default component.exports